// @ts-nocheck
/**
 * ContentsToolbar component.
 * Toolbar with action buttons for the Contents view.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, Input } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import Popup from '@plone/volto/components/theme/Popup/Popup';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { contentsMessages as messages } from '../messages/contentsMessages';

import {
  cutSVG,
  deleteSVG,
  copySVG,
  tagSVG,
  renameSVG,
  semaphoreSVG,
  uploadSVG,
  propertiesSVG,
  pasteSVG,
  zoomSVG,
  clearSVG,
} from '../icons';

/**
 * ContentsToolbar component
 */
export const ContentsToolbar = ({
  selected,
  hasClipboardAction,
  filter,
  onUpload,
  onRename,
  onWorkflow,
  onTags,
  onProperties,
  onCut,
  onCopy,
  onPaste,
  onDelete,
  onChangeFilter,
  intl,
}) => {
  return (
    <Menu secondary attached className="top-menu">
      <Menu.Menu className="top-menu-menu">
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onUpload}
              className="upload"
              aria-label={intl.formatMessage(messages.upload)}
            >
              <Icon
                name={uploadSVG}
                color="#007eb1"
                size="24px"
                className="upload"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.upload)}
          size="mini"
        />
      </Menu.Menu>
      <Menu.Menu className="top-menu-menu">
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onRename}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.rename)}
            >
              <Icon
                name={renameSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="rename"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.rename)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onWorkflow}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.state)}
            >
              <Icon
                name={semaphoreSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="semaphore"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.state)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onTags}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.tags)}
            >
              <Icon
                name={tagSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="tag"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.tags)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onProperties}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.properties)}
            >
              <Icon
                name={propertiesSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="properties"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.properties)}
          size="mini"
        />
      </Menu.Menu>
      <Menu.Menu className="top-menu-menu">
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onCut}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.cut)}
            >
              <Icon
                name={cutSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="cut"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.cut)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onCopy}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.copy)}
            >
              <Icon
                name={copySVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="copy"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.copy)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onPaste}
              disabled={!hasClipboardAction}
              aria-label={intl.formatMessage(messages.paste)}
            >
              <Icon
                name={pasteSVG}
                color={selected ? '#826a6a' : 'grey'}
                size="24px"
                className="paste"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.paste)}
          size="mini"
        />
        <Popup
          trigger={
            <Menu.Item
              icon
              as={Button}
              onClick={onDelete}
              disabled={!selected}
              aria-label={intl.formatMessage(messages.delete)}
            >
              <Icon
                name={deleteSVG}
                color={selected ? '#e40166' : 'grey'}
                size="24px"
                className="delete"
              />
            </Menu.Item>
          }
          position="top center"
          content={intl.formatMessage(messages.delete)}
          size="mini"
        />
      </Menu.Menu>
      <Menu.Menu position="right" className="top-menu-searchbox">
        <div className="ui right aligned category search item">
          <Input
            type="text"
            transparent
            placeholder={intl.formatMessage(messages.filter)}
            size="small"
            value={filter}
            onChange={onChangeFilter}
          />
          {filter && (
            <Button
              className="icon icon-container"
              onClick={() => {
                onChangeFilter('', { value: '' });
              }}
            >
              <Icon name={clearSVG} size="30px" color="#e40166" />
            </Button>
          )}
          <Icon
            name={zoomSVG}
            size="30px"
            color="#007eb1"
            className="zoom"
            style={{ flexShrink: '0' }}
          />
          <div className="results" />
        </div>
      </Menu.Menu>
    </Menu>
  );
};

ContentsToolbar.propTypes = {
  selected: PropTypes.bool.isRequired,
  hasClipboardAction: PropTypes.bool.isRequired,
  filter: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
  onWorkflow: PropTypes.func.isRequired,
  onTags: PropTypes.func.isRequired,
  onProperties: PropTypes.func.isRequired,
  onCut: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ContentsToolbar);
